<template>
  <div class="text-center">
    <v-btn text small @click.prevent="cancelModalOpened = true;">
      <span class="text--gray-darken1 font-weight-bold">{{
        $t("button.cancel")
      }}</span>
    </v-btn>
    <v-dialog
      transition="fade-transition"
      persistent
      ref="dialog"
      v-model="cancelModalOpened"
    >
      <v-card class="">
        <v-form ref="form">
          <v-card-title class="d-flex align-center justify-start">
            <v-icon size="20" class="mr-3" color="orange">$plans</v-icon>
            <h6 class>{{ $t('heading.cancelServiceModal.title') }}</h6>
            <v-btn x-small icon  @click="cancelModalOpened = false;" class="ml-auto">
              <v-icon size="24" color="gray">$close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider class="mb-6" />

          <v-card-text class="pb-8">
            <div class="login-message login-message--warning mb-6">
              <div class="login-message__icon-box">
                <v-icon size="24" color="warning">$stars</v-icon>
              </div>
              <div class="login-message__text-box">
                <h6 class="p-3 login-message__title">
                  {{ $t('heading.cancelServiceModal.alert.title') }}
                </h6>
                <p class="mb-0 p-3 login-message__desc">
                  {{ $t('heading.cancelServiceModal.alert.text') }}
                </p>
              </div>
            </div>
            
            <v-row class="my-0">
              <v-col
                cols="12"
                class="py-0"
              >
                <label
                  class="base--text p-3 mb-1"
                  >
                  {{ $t('heading.cancelServiceModal.reason.label') }}
                </label>
                <v-select
                  v-model="reason"
                  :items="reasons"
                  @change="otherReason == '' && (otherReason = reason)"
                  outlined
                  required
                  :placeholder="$t('heading.cancelServiceModal.reason.placeholder')"
                  class="mb-0 mt-2"
                />
              </v-col>
              <v-col
                cols="12"
                class="py-0 mt-4"
              >
                <label
                  class="base--text p-3 mb-1"
                  >
                  {{ $t('heading.cancelServiceModal.describe.label') }}
                </label>
                <v-textarea
                  v-model="otherReason"
                  required
                  :rules="[(v) => v.length > 9 || $t($t('heading.cancelServiceModal.describe.minimum'))]"
                  class="mb-0 mt-2"
                  outlined
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions
            class="pt-0 d-flex flex-column align-center justify-space-between"
          >
            <v-btn 
              block
              elevation="0"
              large
              :loading="submitting" 
              color="orange" 
              :disabled="!reason || otherReason.length < 10"
              @click="submit()"
              >
              <span class="white--text">
                {{ $t('button.submit') }}
              </span>
            </v-btn>
            <v-btn 
              block
              elevation="0"
              large
              text
              class="mt-2"
              @click="cancelModalOpened = false;"
            >
              <span class="text--gray-darken1">
                {{ $t('button.dismiss') }}
              </span>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/apis/Api";
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      cancelModalOpened: false,
      reason: "",
      otherReason: "",
      reasons: [
        this.$t('heading.cancelServiceModal.reason.option.performance'),
        this.$t('heading.cancelServiceModal.reason.option.expensive'),
        this.$t('heading.cancelServiceModal.reason.option.support'),
        this.$t('heading.cancelServiceModal.reason.option.technical'),
        this.$t('heading.cancelServiceModal.reason.option.panel'),
        this.$t('heading.cancelServiceModal.reason.option.other'),
      ],
      submitting: false,
    };
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.submitting = true;
      Api.put(`/services/${this.service.id}/cancel`, {
        reason: this.otherReason,
      })
        .then(() => {
          this.$emit("service-cancelled", this.service.id);
          this.cancelModalOpened = false;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
